/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import ReactPlayer from 'react-player';
import queryString from 'query-string';
// import { findDOMNode } from "react-dom";
import screenfull from 'screenfull';
import Hotkeys from 'react-hot-keys';

import PartList from '../containers/player/PartList';
// import PauseGoods from "../containers/player/PauseGoods";

import Setting from '../components/player/Setting';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

//import Reactpip from 'react-picture-in-picture'

import Tooltip from '@material-ui/core/Tooltip';
import $ from 'jquery';
import { Base64 } from 'js-base64';

import { isMobile, isAndroid, isIOS } from 'react-device-detect';
// const _keyStr ="C012V45c6ky89AbdeBDFxHGIKwzLNrOPMST*UW-XZa7fgEhijJlnQRo3pYqstuvm_";

class Player extends PureComponent {
  state = {
    playing: false,
    playing2: false,
    played: 0,
    loaded: 0,
    muted: false,
    duration: 0,
    volume: 0.5,
    playbackRate: 1.0,
    partShow: false,
    //mouseScreen: false,
    isHovering: false,
    isSetting: false,
    soundOn: false,
    isOpeningSkip: false,
    isEndingSkip: false,
    isFullScreen: false,

    menuBackOn: false,
    menuPart: false,
    menuPlay: false,
    menuPrev10: false,
    menuNext10: false,
    menuVolume: false,
    menuSetting: false,
    menuFull: false,
    menuPip: false,

    menuRate: false,
    menuKeyboard: false,
    menuNext: false,

    pip: false,
    isLoding: true,
    showRate: false,
    showKeyboard: false,
    snapshots: '',
    //display: 'none'
  };
  _isMounted = false;
  _adPlay = false;
  timer = 0;
  interval = null;
  pos = '';
  isDragging = false;
  mouseDown = false;
  mouseOver = false;
  hoverTime = 0;
  sImg = '';

  componentDidMount = async () => {
    const { location } = this.props;
    this._isMounted = true;
    this.mouseDown = false;
    // this.mouseOver = false;
    document.querySelector('.snapshotContainer').style.display = 'none';
    const parseUrl = queryString.parse(location.search);
    let encodeUrl = parseUrl.u;
    // let pos;

    // var body = document.querySelector('body');
    // body.addEventListener('click', this.clickBodyEvent);

    if (encodeUrl === '' || encodeUrl === null || encodeUrl === undefined) {
      encodeUrl = this.props.childProps.u;
      this.pos = 'pop';
    } else {
      this.pos = 'line';
    }

    if (encodeUrl === '' || encodeUrl === null || encodeUrl === undefined) {
      /*
            this.setState({
                display: 'none'
            })
            */
    } else {
      const base64Data = await this._getBase64Decode(encodeUrl);
      const decodeUrl = base64Data.data.codeString;
      ////console.log(decodeUrl)
      const decodeUrlArr = decodeUrl.split('|');

      const contentPartSerial = decodeUrlArr[0];
      const subPartSerial2 = decodeUrlArr[1];
      const subPartSerial3 = decodeUrlArr[2];
      // const part = decodeUrlArr[3];

      this._onInitPlay(contentPartSerial, subPartSerial2, subPartSerial3);

      /*
            this.setState({
                display: ''
            })
            */
    }

    document.addEventListener('fullscreenchange', (event) => {
      // document.fullscreenElement will point to the element that
      // is in fullscreen mode if there is one. If there isn't one,
      // the value of the property is null.
      if (document.fullscreenElement) {
        this.setState({
          isFullScreen: true,
          isHovering: false,
        });
      } else {
        this.setState({
          isFullScreen: false,
        });
      }
    });
  };
  /*
    UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
        // return false 하면 업데이트를 안함
        return this.props.childProps.u !== nextProps.childProps.u
        //return true;
    }
    componentWillReceiveProps = async (nextProps) => {
        const { setPlayUrl } = this.props;
      if(this.props.childProps.u !== nextProps.childProps.u) {
        
        this._isMounted = true
        const { location } = this.props;

        const parseUrl = queryString.parse(location.search);
        let encodeUrl = parseUrl.u;
        let pos

        var body = document.querySelector("body");
        body.addEventListener('click', this.clickBodyEvent);


        if(encodeUrl ==='' || encodeUrl === null || encodeUrl === undefined) {
            encodeUrl = nextProps.childProps.u
            this.pos = 'pop'
        } else {
            this.pos = 'line'
        } 
        
        //console.log(encodeUrl)
        if(encodeUrl ==='' || encodeUrl === null || encodeUrl === undefined) { 
            //setPlayUrl('')
            this.setState({
                display: 'none',
                playing: false
            })

        } else {
            //alert(0)
            const base64Data = await this._getBase64Decode(encodeUrl)
            
            const decodeUrl = base64Data.data.codeString
            ////console.log(decodeUrl)
            const decodeUrlArr = decodeUrl.split('|')
            
            const contentPartSerial = decodeUrlArr[0]
            const subPartSerial2 = decodeUrlArr[1]
            const subPartSerial3  = decodeUrlArr[2]
            const part = decodeUrlArr[3]

            this._onInitPlay(contentPartSerial, subPartSerial2, subPartSerial3)

            this.setState({
                display: ''
            })
        }


      }
        
    }
    */
  componentWillUnmount = () => {
    this._isMounted = false;
    // var body = document.querySelector('body');
    // body.removeEventListener('click', this.clickBodyEvent);
  };
  // clickBodyEvent = (event) => {
  //   var target = event.target;
  //   var eventTarget = event.currentTarget.querySelector('.control'); //float_left   //.vod_menu_btn
  //   // console.log(target, eventTarget);
  //   //console.log(target, eventTarget)
  //   //this._showMenu()
  //   if (target === eventTarget) {
  //     //this._onTogglePart()
  //     //this._showMenu()
  //   } else {
  //     //this._showMenu()
  //   }
  //   ////console.log(target)
  //   ////console.log(eventTarget)
  // };
  // onPipWindowResize = (event) => {};
  _onInitPlay = async (contentPartSerial, subPartSerial2, subPartSerial3) => {
    // const { duration } = this.state;
    const { loginId, aParam } = this.props;

    //const parseUrl = queryString.parse(location.search);
    //const encodeUrl = parseUrl.u

    //if(encodeUrl ==='' || encodeUrl === null || encodeUrl === undefined) {

    //} else {
    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 이용이 가능합니다.');
    } else {
      ////console.log(encodeUrl)
      //const base64Data = await this._getBase64Decode(encodeUrl)
      ////console.log(base64Data)
      //const decodeUrl = base64Data.data.codeString
      ////console.log(decodeUrl)
      //const decodeUrlArr = decodeUrl.split('|')

      //const contentPartSerial = decodeUrlArr[0]
      //const subPartSerial2 = decodeUrlArr[1]
      //const subPartSerial3  = decodeUrlArr[2]
      //const part = decodeUrlArr[3]

      if (
        subPartSerial2 === '' ||
        subPartSerial2 === null ||
        subPartSerial2 === undefined ||
        subPartSerial2 === 0
      ) {
        toast.warn('파라메터가 누락되었습니다.');
      } else {
        //이용권, 포인트 체크
        const date = new Date();
        const timeStemp = moment(date)
          .add(10, 'minutes')
          .format('YYYYMMDDHHmmss');
        //let param = this.encode(timeStemp)
        //let crypParam = timeStemp + '|aniplus|' + subPartSerial2 + '/' + loginId
        let crypParam =
          timeStemp + '|was|' + subPartSerial2 + '/' + loginId + '@' + aParam;

        const base64Data = await this._getBase64Encode(crypParam);
        crypParam = base64Data.data.codeString;
        // console.log(crypParam);

        //console.log(crypParam)

        const result = await this._onPlayApi(subPartSerial2, crypParam);
        if (result) {
          const intReturn = result.data[0].intReturn;
          const nextList = result.data[0].listData;

          //console.log(result.data[0].mediaTime)

          if (intReturn === 0 || intReturn === 10) {
            const fileName480p = result.data[0].fileName480p;
            const fileName720p = result.data[0].fileName720p;
            const fileName1080p = result.data[0].fileName1080p;

            // const use1080 = result.data[0].use1080;
            // const adFileName = result.data[0].adFileName;
            const pos = result.data[0].pos;
            const contentPartSerial = result.data[0].contentPartSerial;
            const contentSerial = result.data[0].contentSerial;
            const subTitle = result.data[0].subTitle;
            const title = result.data[0].title;
            const mediaTime = result.data[0].mediaTime;
            const imageLO = result.data[0].imageLO;
            const opStartTime = result.data[0].opStartTime;
            const opEndTime = result.data[0].opEndTime;
            const edStartTime = result.data[0].edStartTime;
            const edEndTime = result.data[0].edEndTime;

            const bitrate = result.data[0].bitrate;
            const autoNext = result.data[0].autoNext;
            const autoSkip = result.data[0].autoSkip;
            const autoSkipEnd = result.data[0].autoSkipEnd;
            const wishFlag = result.data[0].wishFlag;
            let videoSource = '';

            //플레이어 설정 값 가져올것..

            ////console.log('pos ===>')
            ////console.log(pos)
            ////console.log(pos / mediaTime)
            ////console.log('duration ===>')
            ////console.log(duration)

            // //영생 재생 종료 후 광고 재생.
            // const adResult = await this._onAdApi(contentSerial);
            // const adIntReturn = adResult.data[0].intReturn;
            // //console.log('adResult', adResult)

            let adList;

            // if (adIntReturn === 0) {
            //   adList = adResult.data[0].listData;
            // }

            //console.log(bitrate)
            if (bitrate === '720P') {
              videoSource = fileName720p;
            } else if (bitrate === '1080P') {
              if (
                fileName1080p === '' ||
                fileName1080p === null ||
                fileName1080p === undefined
              ) {
                videoSource = fileName720p;
              } else {
                videoSource = fileName1080p;
              }
            } else if (bitrate === '480P') {
              videoSource = fileName480p;
            } else {
              videoSource = fileName720p;
            }

            const imgSource =
              videoSource.substr(0, videoSource.lastIndexOf('/')) +
              '/image.gif';
            console.log(imgSource);
            ////console.log(fileName720p)
            //this.video.url = fileName720p
            // if (isAndroid || isIOS) {
            //   console.log(videoSource);
            //   window.open(videoSource);
            // } else {
            if (this._isMounted) {
              //console.log('setState...')
              this._onPlayerOver();
              this.setState({
                url: videoSource,
                url2: fileName720p,
                played: pos === 0 ? 0 : pos / mediaTime,
                loaded: 0,
                //playing: true,
                fileName480p,
                fileName720p,
                fileName1080p,
                subTitle,
                title,
                contentSerial,
                contentPartSerial,
                imageLO: imageLO,
                mediaTime: mediaTime,
                opStartTime: opStartTime,
                opEndTime: opEndTime,
                edStartTime: edStartTime,
                edEndTime: edEndTime,
                bitrate: bitrate,
                autoNext: autoNext,
                autoSkip: autoSkip,
                autoSkipEnd: autoSkipEnd,
                wishFlag: wishFlag,
                adList: adList ? adList : null,
                nextList: nextList ? nextList : null,
                imgSource: imgSource,
              });

              //이어보기
              if (pos > 0) {
                this.video.seekTo(parseFloat(pos / mediaTime));
                // console.log(pos / mediaTime);
                // if (!isMobile) {
                //   // setTimeout(() => {
                setTimeout(() => {
                  this.video2.seekTo(parseFloat(pos / mediaTime));
                }, 1000);

                //   this._shoot(
                //     this.video2.player.player.player,
                //     parseFloat(pos / mediaTime),
                //     0
                //   );
                //   //   //console.log('shoot');
                //   // }, 1000);
                // }

                // this._shoot(this.video2.player.player.player);
              }
            }
            // }
          } else if (intReturn === -7 || intReturn === -1) {
            toast.warn('서비스 중인 콘텐츠가 아닙니다.');
          } else if (intReturn === -4 || intReturn === -5) {
            toast.warn('이용권 또는 포인트 구매 후 관람이 가능합니다.');
          } else if (intReturn === -2) {
            toast.warn('19세 미만은 관람이 불가한 작품입니다.');
          } else {
            toast.warn('오류가 발생했습니다.');
          }
        }
      }

      //const { subPartSerial2, subPartSerial3} = this.props.childProps;
      /*
                const date = new Date();
                const timeStemp = moment(date).add(10, 'minutes').format('YYYYMMDDHHmmss')
                let param = this.encode(timeStemp)
                let crypParam = timeStemp + '|aniplus|' + subPartSerial2 + '/' + loginId
                crypParam = this.encode(crypParam)
                //console.log(crypParam)
                */
    }
    //}
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onPlayApi = (subPartSerial, crypParam) => {
    const { apiUrl, loginId, authId, history } = this.props;
    let token = new Date();
    token = moment(token).format('YYYYMMDDhhmmss');
    token = Base64.encode(token);
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    // console.log('----------player api --------');
    return axios
      .post(
        apiUrl + '/vodUrl',
        {
          params: {
            userid: loginId,
            authId: authId,
            subPartSerial: subPartSerial,
            //param: param,
            crypParam: crypParam,
            token: token,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.warn('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _refreshToken = async () => {
    const { history, apiUrl, location, setLoginId, setAuthId, loginId } =
      this.props;
    const parseUrl = queryString.parse(location.search);
    let encodeUrl = parseUrl.u;

    if (encodeUrl === '' || encodeUrl === null || encodeUrl === undefined) {
      encodeUrl = this.props.childProps.u;
    } else {
    }

    const base64Data = await this._getBase64Decode(encodeUrl);
    const decodeUrl = base64Data.data.codeString;
    ////console.log(decodeUrl)
    const decodeUrlArr = decodeUrl.split('|');

    const contentPartSerial = decodeUrlArr[0];
    const subPartSerial2 = decodeUrlArr[1];
    const subPartSerial3 = decodeUrlArr[2];

    const rt = localStorage.getItem('rt');

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onInitPlay(contentPartSerial, subPartSerial2, subPartSerial3);
    } else {
      //this._onLogout()
      this.setCookie('account', '');
      this.setCookie('ad', '');
      this.setCookie('at', '');
      this.setCookie('rt', '');
      this.setCookie('ni', '');
      this.setCookie('ic', '');

      setLoginId('');
      setAuthId('');

      localStorage.removeItem('at');
      localStorage.removeItem('rt');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onAdApi = (contentSerial) => {
    const { apiUrl } = this.props;
    //const { contentSerial } = this.state;

    //console.log(apiUrl + '/videoAd?contentSerial=' + contentSerial)
    return axios(apiUrl + '/videoAd?contentSerial=' + contentSerial)
      .then((response) => response)
      .catch((error) => {
        //console.log('do net get ad video')
      });
  };
  /*
    _onSetLog = async (sec) => {
        const result = await this._onSetLog(sec)
        const intReturn = result.data[0].intReturn
    }
    */
  _onSetLogApi = (sec) => {
    const { apiUrl, loginId } = this.props;
    const { contentPartSerial } = this.state;

    //console.log(apiUrl + 'setLog?contentPartSerial=' + contentPartSerial + '&pos=' + sec + 'userid=' + loginId)
    fetch(
      apiUrl +
        '/setLog?userid=' +
        loginId +
        '&contentPartSerial=' +
        contentPartSerial +
        '&pos=' +
        sec
    );
    // .then((response) => response.json())
    // //.then(json => //console.log(json))
    // .catch((err) => console.log(err));

    /*
        return axios.post(apiUrl + '/setLog', {
            params: {
                userid: loginId,
                contentPartSerial: contentPartSerial,
                pos: sec
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })
        */
  };
  _getB64e = (codeString) => {
    const { aspUrl } = this.props;
    return axios(aspUrl + '/b64e.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Encode = (codeString) => {
    const { aspUrl, pkg, loginId } = this.props;
    return axios(
      aspUrl +
        '/base64encode_wd.asp?codeString=' +
        codeString +
        '&p=' +
        pkg +
        '&i=' +
        loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Decode = (codeString) => {
    const { aspUrl } = this.props;
    //console.log(aspUrl + '/base64decode.asp?codeString=' + codeString)
    return axios(aspUrl + '/base64decode.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _onReady = () => {
    // const { played } = this.state;
    //console.log('onReady...');
    setTimeout(() => {
      this.setState({
        playing: true,
        //isHovering: false,
        //isLoding: false,
      });
    }, 500);
  };

  _onReady2 = () => {
    //console.log('ready2');
  };
  _onSeek = () => {
    //console.log('onSeek');
    this.setState({
      isLoding: false,
      //isHovering: false,
      //playing: true,
    });
  };
  _onSeek2 = (pos) => {
    //console.log('seek2');
  };
  _onError = () => {
    // toast.error('영상을 로드하는 중 오류가 발생했습니다.');
  };
  _onStart = () => {
    // console.log('onStart...');
    this.setState({
      isLoding: false,
      // isHovering: false,
    });
  };
  _onProgress = (state) => {
    const {
      adList,
      played,
      loaded,
      duration,
      opEndTime,
      opStartTime,
      edStartTime,
      edEndTime,
      autoNext,
      autoSkip,
      autoSkipEnd,
    } = this.state;
    ////console.log(state.played)
    ////console.log('sec ==> ')
    ////console.log(parseInt(data.playedSeconds.toFixed(0)))

    const mod = state.playedSeconds.toFixed(0) % 10;
    ////console.log(mod)
    ////console.log(data.playedSeconds.toFixed(0))
    // console.log(loaded, state.loaded);
    //광고영상
    if (this._adPlay === false) {
      if (mod === 0) {
        this._onSetLogApi(parseInt(state.playedSeconds.toFixed(0)));
      }
    }

    /*오프닝 스킵표시*/
    if (autoSkip === 'Y') {
      if (
        parseInt(duration * played) > parseInt(opStartTime) &&
        parseInt(duration * played) < parseInt(opEndTime)
      ) {
        this._skipTo(opEndTime);
      }
    } else {
      if (parseInt(opEndTime) - parseInt(opStartTime) > 0) {
        if (
          parseInt(duration * played) > parseInt(opStartTime) &&
          parseInt(duration * played) < parseInt(opEndTime)
        ) {
          this.setState({
            isOpeningSkip: true,
          });
        } else {
          this.setState({
            isOpeningSkip: false,
          });
        }
      } else {
        this.setState({
          isOpeningSkip: false,
        });
      }
    }

    /*엔딩 스킵표시*/
    if (autoSkipEnd === 'Y') {
      if (
        parseInt(duration * played) > parseInt(edStartTime) &&
        parseInt(duration * played) < parseInt(edEndTime)
      ) {
        this._skipTo(edEndTime);
      }
    } else {
      if (parseInt(edEndTime) - parseInt(edStartTime) > 0) {
        if (
          parseInt(duration * played) > parseInt(edStartTime) &&
          parseInt(duration * played) < parseInt(edEndTime)
        ) {
          this.setState({
            isEndingSkip: true,
          });
        } else {
          this.setState({
            isEndingSkip: false,
          });
        }
      } else {
        this.setState({
          isEndingSkip: false,
        });
      }
    }

    if (state.played === 1) {
      //끝까지 재생됨.
      //console.log('==>adList')
      //console.log(adList)
      if (this._adPlay === false) {
        if (adList) {
          this.setState({
            url: adList[0].videoUrl,
            playing: true,
          });
          this._adPlay = true;
        } else {
          this._adPlay = false;
          if (autoNext === 'Y') {
            //다음화 재생.
            //console.log('다음화 재생.')
            this._onNextPlayInfo();
          } else {
            //종료.
            //console.log('history.back..')
          }
        }
      } else {
        if (autoNext === 'Y') {
          //다음화 재생.
          //console.log('다음화 재생.')
          this._onNextPlayInfo();
        } else {
          //종료.
          //console.log('history.back..')
        }
      }
    }
    if (!this.state.seeking) {
      if (!this.state.seeking) {
        this.setState(state);
      }
    }
    //재생 로그 기록...
  };
  _onChangeBitrate = async (bitrate) => {
    const { fileName480p, fileName720p, fileName1080p } = this.state;
    let videoSource = '';

    const result = await this._changeBitrateApi(bitrate);
    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      if (bitrate === '720P') {
        videoSource = fileName720p;
      } else if (bitrate === '1080P') {
        videoSource = fileName1080p;
      } else if (bitrate === '480P') {
        videoSource = fileName480p;
      } else {
        videoSource = fileName720p;
      }

      this.setState({
        url: videoSource,
        bitrate: bitrate,
        isSetting: false,
        //played: played
      });
    } else {
      toast.warn('화질 설정 변경중 오류가 발생했습니다.');
    }
  };
  _changeBitrateApi = (bitrate) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/changeBitrate', {
        params: {
          userid: loginId,
          bitrate: bitrate,
        },
      })
      .then((response) => response)
      .catch((error) => {
        alert('오류가 발생했습니다.');
      });
  };
  _onChangeAutoNext = async (autoNext) => {
    const result = await this._changeAutoNextApi(autoNext);
    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      this.setState({
        isSetting: false,
        autoNext: autoNext,
        //played: played
      });
    }
  };
  _changeAutoNextApi = (autoNext) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/changeAutoNext', {
        params: {
          userid: loginId,
          autoNext: autoNext,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.warn('오류가 발생했습니다.');
      });
  };
  _onChangeAutoSkip = async (autoSkip) => {
    const result = await this._changeAutoSkipApi(autoSkip);
    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      this.setState({
        isSetting: false,
        autoSkip: autoSkip,
        //played: played
      });
    }
  };
  _changeAutoSkipApi = (autoSkip) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/changeAutoSkip', {
        params: {
          userid: loginId,
          autoSkip: autoSkip,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.warn('오류가 발생했습니다.');
      });
  };
  _onChangeAutoSkipEnd = async (autoSkipEnd) => {
    const result = await this._changeAutoSkipEndApi(autoSkipEnd);
    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      this.setState({
        isSetting: false,
        autoSkipEnd: autoSkipEnd,
        //played: played
      });
    }
  };
  _changeAutoSkipEndApi = (autoSkipEnd) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/changeAutoSkipEnd', {
        params: {
          userid: loginId,
          autoSkipEnd: autoSkipEnd,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.warn('오류가 발생했습니다.');
      });
  };

  /*
    _onPlay = () => {
        const { playing } = this.state;
        this.setState({
            playing: true
        })
    }
    _onPause = () => {
        const { playing } = this.state;
        this.setState({
            playing: false
        })
    }
    */
  _onPlayToggle = () => {
    const { playing } = this.state;

    if (this._isMounted) {
      this.timer = 0;

      this.setState({
        playing: !playing,
      });

      /*
            if(playing) {
                this._onPlayerOver()
            } else {
                this._onPlayerOut()
            }
            */
    }
  };
  _onStop = () => {
    //const { url } = this.state;
    if (this._isMounted) {
      this.timer = 0;
      this.setState({
        url: '',
        //played: 0,
        //loaded: 0,
        playing: false,
      });
    }
  };
  _onDuration = (duration) => {
    const { played } = this.state;

    this.setState({
      duration,
    });
    //setTimeout(() => {
    //alert(0)
    if (this.video) {
      this.video.seekTo(parseFloat(played));
    }
    //}, 100);
  };
  // _onSeekChange = (e) => {
  //   //console.log(parseFloat(e.target.value))
  //   if (this._isMounted) {
  //     this.timer = 0;
  //     this.setState({ played: parseFloat(e.target.value) });
  //   }
  // };
  // _onSeekMouseDown = (e) => {
  //   if (this._isMounted) {
  //     this.timer = 0;
  //     this.setState({ seeking: true });
  //   }
  // };

  // _onSeekMouseUp = (e) => {
  //   if (this._isMounted) {
  //     this.setState({ seeking: false });
  //     this.video.seekTo(parseFloat(e.target.value));
  //   }
  // };
  // _onVolumeChange = (e) => {
  //   if (this._isMounted) {
  //     this.timer = 0;
  //     const volume = parseFloat(e.target.value);
  //     this.setState({
  //       volume,
  //     });
  //   }
  // };
  // _onToggleMuted = () => {
  //   if (this._isMounted) {
  //     this.timer = 0;
  //     this.setState({ muted: !this.state.muted });
  //   }
  // };
  _onSetPlaybackRate = (val) => {
    //const playbackRate = parseFloat(e.target.value)
    /*
        const { playbackRate } = this.state;
        let val
        
        if(playbackRate === 1) {
            val = 1.5
        } else if(playbackRate === 1.5) {
            val = 2
        } else if(playbackRate === 2) {
            val = 2.5
        } else if(playbackRate === 2.5) {
            val = 3
        } else if(playbackRate === 3) {
            val = 1
        }
        */
    if (this._isMounted) {
      this.timer = 0;
      this.setState({
        playbackRate: val,
      });
    }
  };

  _onSetPlaybackRatePlu = () => {
    //const playbackRate = parseFloat(e.target.value)

    const { playbackRate } = this.state;
    let val;

    if (playbackRate === 1) {
      val = 1.5;
    } else if (playbackRate === 1.5) {
      val = 2;
    } else if (playbackRate === 2) {
      val = 2.5;
    } else if (playbackRate === 2.5) {
      val = 3;
    } else if (playbackRate === 3) {
      val = 1;
    }

    if (this._isMounted) {
      this.timer = 0;
      this.setState({
        playbackRate: val,
      });
    }
  };
  _onSetPlaybackRateMin = () => {
    //const playbackRate = parseFloat(e.target.value)
    const { playbackRate } = this.state;
    let val;
    if (playbackRate === 3) {
      val = 2.5;
    } else if (playbackRate === 2.5) {
      val = 2;
    } else if (playbackRate === 2) {
      val = 1.5;
    } else if (playbackRate === 1.5) {
      val = 1;
    } else {
      val = 1;
    }
    if (this._isMounted) {
      this.timer = 0;
      this.setState({
        playbackRate: val,
      });
    }
  };
  /*
    _onFullscreen = () => {
        screenfull.request(findDOMNode(this.player))

        
    }
    */
  _onNextPlayInfo = async () => {
    const result = await this._onNetPlayInfoApi();
    const intReturn = result.data[0].intReturn;
    const nextList = result.data[0].listData;

    //console.log(intReturn)
    if (intReturn === 0) {
      this._onInitPlay(
        nextList[0].contentPartSerial,
        nextList[0].subPartSerial2,
        nextList[0].subPartSerial3
      );
    } else if (intReturn === -1) {
      toast.warn(
        '다음화 자동재생의 경우 무제한 이용권 소지해야 이용이 가능합니다.'
      );
    } else if (intReturn === -2) {
      toast.warn('최종화 이거나 다음화가 아직 업데이트 되지 않았습니다.');
    } else {
      toast.warn('오류가 발생했습니다.');
    }
  };
  _onNetPlayInfoApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentPartSerial } = this.state;

    if (loginId === '' || loginId === null || loginId === undefined) {
    } else {
      //console.log(apiUrl + '/nextPlayInfo?contentPartSerial=' + contentPartSerial + '&userid=' + loginId)
      return axios(
        apiUrl +
          '/nextPlayInfo?contentPartSerial=' +
          contentPartSerial +
          '&userid=' +
          loginId
      )
        .then((response) => response)
        .catch((error) => {
          toast.warn('다음화 정보를 로드 중 오류가 발생했습니다.');
        });
    }
  };
  _onForward = () => {
    const { playedSeconds, duration } = this.state;
    const pos = (playedSeconds + 10) / duration;
    //console.log(playedSeconds)
    //console.log(duration)
    //console.log('===>')
    //console.log(pos)
    if (this._isMounted) {
      this.timer = 0;
      this.video.seekTo(parseFloat(pos));
    }
  };
  _onBackward = () => {
    const { playedSeconds, duration } = this.state;
    const pos = (playedSeconds - 10) / duration;
    //console.log(playedSeconds)
    //console.log(duration)
    //console.log('===>')
    //console.log(pos)
    if (this._isMounted) {
      this.timer = 0;
      this.video.seekTo(parseFloat(pos));
    }
  };
  _onVolumeUp = () => {
    const { volume } = this.state;
    //console.log(parseFloat(volume.toFixed(1)) + 0.1)
    this.timer = 0;
    if (parseFloat(volume.toFixed(1)) + 0.1 < 1) {
      this.setState({
        volume: parseFloat(volume.toFixed(1)) + 0.1,
      });
    } else {
      this.setState({
        volume: 1,
      });
    }
  };
  _onVolumeDonw = () => {
    const { volume } = this.state;
    this.timer = 0;
    if (parseFloat(volume.toFixed(1)) - 0.1 > 0) {
      this.setState({
        volume: parseFloat(volume.toFixed(1)) - 0.1,
      });
    } else {
      this.setState({
        volume: 0,
      });
    }
  };
  _onKeyDown = (keyName, e, handle) => {
    ////console.log("test:onKeyDown", keyName, e, handle)
    e.preventDefault();
  };
  _onKeyUp = (keyName, e, handle) => {
    ////console.log(keyName)
    //e.preventDefault()
    //e.stopPropagation();
    //e.stopImmediatePropagation();
    //e.cancelBubble = true
    //console.log(keyName)

    if (keyName === 'space') {
      this._onPlayToggle();
    } else if (keyName === 'left') {
      //10초 뒤
      this._onBackward();
    } else if (keyName === 'right') {
      //10초 앞
      this._onForward();
    } else if (keyName === 'up') {
      //볼륨 10+
      this._onVolumeUp();
    } else if (keyName === 'down') {
      //볼륨 10-
      this._onVolumeDonw();
    } else if (keyName === 'backspace') {
      this._onBack();
      //닫기
    } else if (keyName === 'pageup') {
      //전체보기
      this._onFullscreen();
    } else if (keyName === 'esc') {
      //전체종료
      this._onBack();
    } else if (keyName === ']') {
      //배속 +
      this._onSetPlaybackRatePlu();
    } else if (keyName === '[') {
      //배속 -
      this._onSetPlaybackRateMin();
    }

    ////console.log("test:onKeyDown", keyName, e, handle)
  };

  _onTogglePart = () => {
    const { partShow } = this.state;

    if (this._isMounted) {
      this.setState({
        partShow: !partShow,
      });
    }

    //if(partShow === false) {
    //this._onPlayerOver()
    //this._onPlayerOut()
    //}
  };
  _onToggleSetting = () => {
    const { isSetting } = this.state;
    if (this._isMounted) {
      this.setState({
        isSetting: !isSetting,
        showRate: false,
        showKeyboard: false,
      });
    }
  };
  /*
    _onShowPart = () => {
        //console.log('..show...')
        const { partShow } = this.state;

        this.setState({
            partShow: true
        })
    }
    _onHidePart = () => {
        const { partShow } = this.state;

        this.setState({
            partShow: false
        })
    }
    */
  /*
    _onToggleScreen = (val) => {
        this.setState({
            mouseScreen: val
        })
        ////console.log('....')

    }
    */
  _onPlayerOver = (e) => {
    const { isHovering } = this.state;
    //console.log('mouseOver')
    if (this.interval) {
      clearInterval(this.interval);
    }

    if (this._isMounted) {
      if (isHovering === false) {
        this.setState({
          isHovering: true,
        });

        this.interval = setInterval(() => {
          this._onMouseMoveCheck(e);
        }, 1000);
      }
    }
  };
  _onPlayerOut = () => {
    //console.log('mouseOut')
    this.timer = 0;
    clearInterval(this.interval);
    if (this._isMounted) {
      this.setState({
        isHovering: false,
        soundOn: false,
        showRate: false,
        showKeyboard: false,
        isSetting: false,
        partShow: false,
        menuBackOn: false,
        menuPart: false,
        menuPlay: false,
        menuPrev10: false,
        menuNext10: false,
        menuVolume: false,
        menuSetting: false,
        menuFull: false,
        menuPip: false,

        menuRate: false,
        menuKeyboard: false,
        // snapshots: '',
      });
    }
  };
  _onPlayerMove = () => {
    const { isHovering } = this.state;
    if (isHovering) {
      this.timer = 0;
    }
  };
  _onMouseMoveCheck = () => {
    //console.log('mouseMovie');
    const { isHovering, playing } = this.state;
    //console.log('aaa')
    //console.log(this.timer);
    if (playing) {
      if (isHovering) {
        this.timer = this.timer + 1;
        // console.log(this.timer);

        if (this.timer >= 5) {
          this.timer = 0;
          if (this._isMounted) {
            clearInterval(this.interval);
            this.isDragging = false;
            this.mouseDown = false;
            // this.mouseOver = false;
            document.querySelector('.snapshotContainer').style.display = 'none';

            this._onPlayerOut();

            // this.setState({
            //   isHovering: false,
            //   //snapshots: '',
            // });
          }
        }
      } else {
        if (this._isMounted) {
          this.timer = 0;
          clearInterval(this.interval);
          this.mouseDown = false;
          if (document.querySelector('.snapshotContainer')) {
            document.querySelector('.snapshotContainer').style.display = 'none';
          }
          // this.mouseOver = false;
          // this.setState({
          //   snapshots: '',
          // });
        }
      }
    } else {
      this.mouseDown = false;
      if (document.querySelector('.snapshotContainer')) {
        document.querySelector('.snapshotContainer').style.display = 'none';
      }

      // this.mouseOver = false;
      this.setState({
        isHovering: true,
      });
    }
  };

  _onBack = () => {
    const { history, setPlayUrl } = this.props;
    if (this.pos === 'pop') {
      setPlayUrl('');
    } else {
      history.goBack();
    }
  };

  _onFullscreen = () => {
    const element = document.getElementsByClassName('vod_play_group')[0];

    setTimeout(() => {
      document.querySelector('.snapshotContainer').style.display = 'none';
    }, 300);
    //screenfull.request(findDOMNode(this.player))
    //document.element.requestFullscreen();
    if (screenfull.isFullscreen) {
      document.exitFullscreen();
    } else {
      screenfull.request(element);
    }
    clearInterval(this.interval);
  };
  _msToTime = (duration) => {
    // let milliseconds = parseInt((duration % 1000) / 1000);
    let seconds = parseInt((duration / 1000) % 60);
    let minutes = parseInt((duration / (1000 * 60)) % 60);
    let hours = parseInt((duration / (1000 * 60 * 60)) % 24);

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    return hours + ':' + minutes + ':' + seconds;
  };
  _handleVolumeEvent = (event) => {
    //console.log('volume....')

    const { isHovering } = this.state;
    // this.mouseDown = false;
    var target = event.target;
    // console.log(target);
    let start;
    let width;

    if (
      target.className === 'sound_cur' ||
      target.className === 'sound_line' ||
      target.className === 'sound_ing' ||
      target.className === 'sound_line_remain'
    ) {
      // event.preventDefault();

      this.timer = 0;

      if (event.type === 'mousedown') {
        ////console.log('mouseDown..')
        ////console.log(event.clientX)
        this.mouseDown = true;
        start = $('.sound_line').offset();
        width = $('.sound_line').width();
        //console.log(start.left, width)
        if (event.clientX >= start.left + width) {
          this.setState({
            volume: 1,
          });
        } else if (event.clientX <= start.left) {
          this.setState({
            volume: 0,
          });
        } else {
          const val = (event.clientX - start.left) / width;
          //console.log(val)
          this.setState({
            volume: val,
          });
        }
      } else if (event.type === 'mouseup') {
        this.mouseDown = false;
        setTimeout(() => {
          this.setState({
            isHovering: false,
          });
        }, 1000);
        //console.log('mouseUp..')
      } else if (event.type === 'mousemove') {
        // console.log(this.mouseDown);
        if (this.mouseDown) {
          start = $('.sound_line').offset();
          width = $('.sound_line').width();
          if (event.clientX >= start.left + width) {
            this.setState({
              volume: 1,
            });
          } else if (event.clientX <= start.left) {
            this.setState({
              volume: 0,
            });
          } else {
            const val = (event.clientX - start.left) / width;
            //console.log(val)
            this.setState({
              volume: val,
            });
          }
        }
      }
    }
  };
  _handleVolumeEvent1 = (event) => {
    //console.log('volume....')

    const { isHovering } = this.state;
    // this.mouseDown = false;

    var target = event.target;
    // console.log(target);
    let start;
    let width;

    if (
      target.className === 'sound_cur' ||
      target.className === 'sound_line' ||
      target.className === 'sound_ing' ||
      target.className === 'sound_line_remain'
    ) {
      if (isHovering) {
        this.timer = 0;
      }
      if (event.type === 'touchstart') {
        ////console.log('mouseDown..')
        ////console.log(event.clientX)
        const touch = event.touches[0];
        this.mouseDown = true;
        start = $('.sound_line').offset();
        width = $('.sound_line').width();
        const val = (touch.pageX - start.left) / width;
        //console.log(val)
        this.setState({
          volume: val,
        });
      } else if (event.type === 'touchend') {
        this.mouseDown = false;
        //console.log('mouseUp..')
      } else if (event.type === 'touchmove') {
        // console.log(this.mouseDown);
        const touch = event.touches[0];
        if (this.mouseDown) {
          start = $('.sound_line').offset();
          width = $('.sound_line').width();
          if (touch.pageX >= start.left + width) {
            this.setState({
              volume: 1,
            });
          } else if (touch.pageX <= start.left) {
            this.setState({
              volume: 0,
            });
          } else {
            const val = (touch.pageX - start.left) / width;
            //console.log(val)
            this.setState({
              volume: val,
            });
          }
        }
      }
    }
  };

  _handleProgressEvent = (event) => {
    const { isHovering, mediaTime, duration } = this.state;
    // event.preventDefault();
    const width = document.getElementsByClassName('play_line')[0].offsetWidth;
    // this.mouseDown = false;
    var target = event.target;
    //var eventTarget = event.currentTarget.querySelector(".play_line_cur")   //float_left   //.vod_menu_btn

    //console.log(target.className);
    //console.log($('.play_line_cur')[0]);
    // console.log('progress bar mouse event...');
    // console.log(target);
    // console.log($('.play_line_cur')[0]);
    // console.log(event.type);
    if (
      target.className === 'play_line_cur' ||
      target.className === 'play_line_loaded' ||
      target.className === 'play_line' ||
      target.className === 'play_line_ing' ||
      target.className === 'play_line_remain'
    ) {
      //if (isHovering) {
      this.timer = 0;
      //}

      if (event.type === 'mousedown') {
        //console.log('mousedown');
        this.mouseDown = true;

        document.querySelector('.snapshotContainer').style.display = 'none';

        const toPlay = 1 * (event.clientX / width);
        //console.log(toPlay)

        this.video.seekTo(toPlay - 0.05);
        this.setState({
          played: toPlay - 0.05,
          isLoding: true,
        });
      } else if (event.type === 'mouseup') {
        this.mouseDown = false;
        setTimeout(() => {
          this.timer = 4;
        }, 700);

        // setTimeout(() => {
        //   this.setState({
        //     isHovering: false,
        //   });
        // }, 1000);
      } else if (event.type === 'mouseenter') {
        //console.log('mouseenter');
        this.mouseDown = false;

        // this.mouseOver = true;
        document.querySelector('.snapshotContainer').style.display = 'block';
        //console.log('mouse up...');
        ////console.log('mouseUp..')
        ////console.log(event.clientX)
      } else if (event.type === 'mouseleave') {
        // this.mouseOver = false;
        //console.log('mouseleave');
        this.mouseDown = false;

        document.querySelector('.snapshotContainer').style.display = 'none';
        // this.setState({
        //   snapshots: ''
        // })
        //console.log('mouse out...');
      } else if (event.type === 'mousemove') {
        this.timer = 0;
        if (this.mouseDown) {
          //console.log('mousedown-move');
          // this.mouseOver = false;
          document.querySelector('.snapshotContainer').style.display = 'none';
          const start = $('.play_line').offset();
          const width = $('.play_line').width();
          if (event.clientX >= start.left + width) {
            this.setState({
              played: 1,
              // snapshots: '',
            });
          } else if (event.clientX <= start.left) {
            this.setState({
              played: 0,
              // snapshots: '',
            });
          } else {
            const toPlay = 1 * (event.clientX / width);
            // console.log(toPlay);
            //console.log(toPlay)
            this.video.seekTo(toPlay - 0.05);
            this.setState({
              played: toPlay - 0.05,
              // snapshots: '',
              isLoding: true,
            });
          }

          // this.mouseDown = true;
          // //play_line
          // //console.log('mouseDown..')
          // //console.log(event.clientX)
          // //const pos = event.clientX / width * 100
          // const toPlay = 1 * (event.clientX / width);
          // console.log(toPlay);
          // //console.log(toPlay)
          // this.video.seekTo(toPlay - 0.05);
          // this.setState({
          //   played: toPlay - 0.05,
          // });
        } else {
          // console.log('mouseup-move');
          document.querySelector('.snapshotContainer').style.display = 'block';
          this.mouseDown = false;
          let toPlay = 1 * (event.clientX / width);

          toPlay = toPlay - 0.05;

          if (toPlay > 1) {
            toPlay = 1;
          }
          if (toPlay < 0) {
            toPlay = 0;
          }

          // console.log(toPlay);
          // if (
          //   toPlay > this.hoverTime + 0.01 ||
          //   toPlay < this.hoverTime - 0.01
          // ) {
          // console.log('스냅샷..');

          this.video2.seekTo(toPlay);

          // console.log(this.hoverTime * 1000);
          //if (this.video2) {
          //console.log(toPlay, this.hoverTime);
          const xpos = event.clientX - 75;
          if (
            toPlay > this.hoverTime + 0.00002 ||
            toPlay < this.hoverTime - 0.00002
          ) {
            //console.log('shoot');
            this._shoot(this.video2.player.player.player, toPlay, xpos);
          }
          this.hoverTime = toPlay;
          // this.snapshotRef.style.left = event.clientX - 75 + 'px';
          // console.log(event.clientX - 75);
          // console.log(this._msToTime(duration * this.hoverTime * 1000));
          // }
          // }
        }
      }
    }
  };
  _shoot = (video, time, xpos) => {
    const { snapshots, duration } = this.state;
    let canvas = this._capture(video);
    // console.log(canvas.toDataURL('image/png'));

    // console.log(canvas.toDataURL('image/webp', 0.1));
    // console.log(this.snapshootImgRef);
    // this.snapshootImgRef.src = canvas.toDataURL('image/webp', 0.1);
    const imgUrl = canvas.toDataURL('image/jpg', 0.1);
    // this.sImg = imgUrl;
    // console.log(this._msToTime(duration * time * 1000));
    const snapTime = this._msToTime(duration * time * 1000);

    const temp = document.createElement('div');
    temp.className = 'snapshots';
    temp.innerHTML = `
      <img
        src=${imgUrl}
        class="snapshotImg"
      />
      <div class="snapshotTime">
        ${snapTime}
      </div>
    `;
    document.querySelector('.snapshotContainer').innerHTML = '';
    document.querySelector('.snapshotContainer').append(temp);
    document.querySelector('.snapshotContainer').style.left = xpos + 'px';
    // console.log(time);
    // console.log(this.sImg);
    // if (imgUrl !== snapshots) {
    // this.setState({
    //   snapshots: imgUrl,
    //   stime: time,
    // });
    // }
  };
  _capture = (video) => {
    let w = 230; //video.videoWidth;
    let h = 150; //video.videoHeight;
    // console.log(w, h);
    let canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    let ctx = canvas.getContext('2d');

    ctx.drawImage(video, 0, 0, w, h);
    // const imgData = ctx.getImageData(0, 0, w, h);
    // console.log(imgData);
    return canvas;
  };
  // _onOutsideSlider = () => {
  //   this.setState({
  //     snapshots: '',
  //   });
  // };

  _handleProgressEvent1 = (event) => {
    const { isHovering } = this.state;
    // event.preventDefault();
    const width = document.getElementsByClassName('play_line')[0].offsetWidth;
    // this.mouseDown = false;
    var target = event.target;
    //var eventTarget = event.currentTarget.querySelector(".play_line_cur")   //float_left   //.vod_menu_btn

    //console.log(target)
    //console.log($('.play_line')[0])
    // console.log('progress bar mouse event...11');
    if (
      target.className === 'play_line_cur' ||
      target.className === 'play_line_loaded' ||
      target.className === 'play_line' ||
      target.className === 'play_line_ing' ||
      target.className === 'play_line_remain'
    ) {
      //console.log('same')

      if (isHovering) {
        this.timer = 0;
      }
      if (event.type === 'touchstart') {
        this.mouseDown = true;
        this.mouseOver = false;
        //console.log(target)
        //console.log(eventTarget)

        //play_line
        //console.log('mouseDown..')
        //console.log(event.clientX)

        //const pos = event.clientX / width * 100
        const touch = event.touches[0];
        // console.log(touch);
        const toPlay = 1 * (touch.pageX / width);

        this.video.seekTo(toPlay - 0.05);
        this.setState({
          played: toPlay - 0.05,
        });
      } else if (event.type === 'touchend') {
        this.mouseDown = false;
        this.mouseOver = false;
        ////console.log('mouseUp..')
        ////console.log(event.clientX)
      } else if (event.type === 'touchmove') {
        // console.log('touchmove...');
        if (this.mouseDown) {
          const start = $('.play_line').offset();
          const width = $('.play_line').width();

          const touch = event.touches[0];
          // console.log(touch);

          if (touch.pageX >= start.left + width) {
            this.setState({
              played: 1,
            });
          } else if (touch.pageX <= start.left) {
            this.setState({
              played: 0,
            });
          } else {
            const toPlay = 1 * (touch.pageX / width);
            // console.log(toPlay);
            //console.log(toPlay)
            this.video.seekTo(toPlay - 0.05);
            this.setState({
              played: toPlay - 0.05,
            });
          }

          // this.mouseDown = true;
          // //play_line
          // //console.log('mouseDown..')
          // //console.log(event.clientX)
          // //const pos = event.clientX / width * 100
          // const toPlay = 1 * (event.clientX / width);
          // console.log(toPlay);
          // //console.log(toPlay)
          // this.video.seekTo(toPlay - 0.05);
          // this.setState({
          //   played: toPlay - 0.05,
          // });
        } else {
        }
      }
    }
  };

  _toggleSound = () => {
    const { soundOn, menuVolume } = this.state;
    if (this._isMounted) {
      this.setState({
        soundOn: !soundOn,
        menuVolume: !menuVolume,
      });
    }
  };
  _skipTo = (pos) => {
    this.video.seekTo(pos);
  };
  _toggleMuted = () => {
    const { muted } = this.state;
    if (this._isMounted) {
      this.setState({
        muted: !muted,
      });
    }
  };
  _toggleBack = () => {
    const { menuBackOn } = this.state;
    if (this._isMounted) {
      this.setState({
        menuBackOn: !menuBackOn,
      });
    }
  };

  _hoverMove = (e) => {
    // console.log('hover mouse move...');
    this.timer = 1;
  };
  _playMouseMove = (e) => {
    // console.log('player moude move...');
  };

  _toggleMenu = () => {
    const { menuPart } = this.state;
    if (this._isMounted) {
      this.setState({
        menuPart: !menuPart,
      });
    }
  };
  _togglePlay = () => {
    const { menuPlay } = this.state;
    this.setState({
      menuPlay: !menuPlay,
    });
  };
  _togglePrev10 = () => {
    const { menuPrev10 } = this.state;
    if (this._isMounted) {
      this.setState({
        menuPrev10: !menuPrev10,
      });
    }
  };
  _toggleNext10 = () => {
    const { menuNext10 } = this.state;
    this.setState({
      menuNext10: !menuNext10,
    });
  };
  _toggleSetting = () => {
    const { menuSetting } = this.state;
    if (this._isMounted) {
      this.setState({
        menuSetting: !menuSetting,
      });
    }
  };
  _toggleFull = () => {
    const { menuFull } = this.state;
    if (this._isMounted) {
      this.setState({
        menuFull: !menuFull,
      });
    }
  };
  _onEnablePIP = () => {
    if (this._isMounted) {
      this.setState({
        pip: true,
        playing: true,
      });
    }
  };
  _onDisablePIP = () => {
    if (this._isMounted) {
      this.setState({
        pip: false,
        playing: true,
      });
    }
  };
  _togglePip = () => {
    const { pip, playing } = this.state;
    if (this._isMounted) {
      if (playing) {
        this.setState({
          pip: !pip,
          playing: true,
        });
      } else {
        toast.warn('화면이 로딩 후 PIP 사용이 가능합니다.');
      }
    }

    /*
        const video = document.getElementsByTagName("video")[0];
        if (!document.pictureInPictureElement) {
            video.requestPictureInPicture()
            .catch(error => {
                toast.error('지원하지 않는 브라우져입니다.')
                // Video failed to enter Picture-in-Picture mode.
            });

            
            } else {
            document.exitPictureInPicture()
            .catch(error => {
                toast.error('지원하지 않는 브라우져입니다.')
                // Video failed to leave Picture-in-Picture mode.
            });
            }
        */
  };
  _toggleMenuPip = () => {
    const { menuPip } = this.state;
    if (this._isMounted) {
      this.setState({
        menuPip: !menuPip,
      });
    }
  };
  _toggleWish = async () => {
    // const { contentSerial } = this.props.childProps;
    const { loginId } = this.props;
    // const { wishFlag } = this.state;

    //console.log(contentSerial, wishFlag)

    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      const result = await this._toggleWishApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      if (this._isMounted) {
        this.setState({
          wishFlag: intReturn,
        });
        //console.log(intReturn)
      }
    }
  };
  _toggleWishApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentSerial } = this.state;

    return axios
      .post(apiUrl + '/wishToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };
  _outMenu = () => {
    const { isHovering } = this.state;

    if (isHovering) {
      this._onPlayerOut();
    }
  };
  _showMenu = (e) => {
    const { isHovering } = this.state;
    //console.log(isHovering);
    // console.log(e.target);
    const target = e.target;
    // const rTarget = e.currentTarget.querySelector('.live_hover');
    // const pTarget = e.currentTarget.querySelector('.vod_play_group');
    //console.log(target);
    //console.log($(e.target).attr('class'));
    // const rTarget = $(e.target).attr('class');
    //console.log(rTarget);
    //console.log(isHovering);
    if (isHovering) {
      if (
        target.className === 'btn_pause' ||
        target.className === 'btn_part' ||
        target.className === 'btn_control' ||
        target.className === 'play_line' ||
        target.className === 'play_line_cur' ||
        target.className === 'play_line_loaded' ||
        target.className === 'play_ing' ||
        target.className === 'play_cur' ||
        target.className === 'play_line_remain' ||
        target.className === 'sound_line' ||
        target.className === 'sound_line_cur' ||
        target.className === 'sound_ing' ||
        target.className === 'sound_line_remain' ||
        target.className === 'sound_cur'
      ) {
        this.timer = 0;
        return;
      } else {
        if (
          target.classNameet === 'btn_play' ||
          target.className === 'btn_next' ||
          target.className === 'btn_pre'
        ) {
          this.isDragging = false;
          this.mouseDown = false;
          this.mouseOver = false;

          setTimeout(() => {
            this._onPlayerOut(e);
          }, 300);
        } else {
          this.isDragging = false;
          this.mouseDown = false;
          this.mouseOver = false;

          setTimeout(() => {
            this._onPlayerOut(e);
          }, 300);
        }
      }
    } else {
      this._onPlayerOver(e);
    }
  };
  _toggleRate = () => {
    const { showRate } = this.state;
    if (this._isMounted) {
      this.setState({
        showRate: !showRate,
        showKeyboard: false,
        isSetting: false,
      });
    }
  };
  _toggleKeyboard = () => {
    const { showKeyboard } = this.state;
    if (this._isMounted) {
      this.setState({
        showKeyboard: !showKeyboard,
        showRate: false,
        isSetting: false,
      });
    }
  };
  _toggleMouseRate = () => {
    const { menuRate } = this.state;

    if (this._isMounted) {
      this.setState({
        menuRate: !menuRate,
      });
    }
  };
  _toggleMouseKeyboard = () => {
    const { menuKeyboard } = this.state;
    if (this._isMounted) {
      this.setState({
        menuKeyboard: !menuKeyboard,
      });
    }
  };
  _toggleMouseNext = () => {
    const { menuNext } = this.state;
    if (this._isMounted) {
      this.setState({
        menuNext: !menuNext,
      });
    }
  };
  // _getThumnail = (e) => {
  //   const { played } = this.state;
  //   let playTime = played * 1000;
  //   //const width = document.getElementsByClassName('play_line')[0].offsetWidth;
  //   //let playTime = 1 * (e.clientX / width);

  //   console.log(playTime);
  //   let video = this.video.player.player.player;

  //   video.currentTime = playTime;

  //   let canvas = document.getElementById('canvas');
  //   console.log(canvas);
  //   let ctx = canvas.getContext('2d');
  //   console.log(ctx);
  //   setTimeout(() => {
  //     ctx.drawImage(video, 0, 0, 128, 72);
  //   }, 700);
  // };
  // _ballDrag = (e) => {
  //   this.isDragging = true;
  // };
  // _ballMove = (e) => {
  //   if (this._isDragging === true) {
  //     console.log('drag...');
  //   }
  // };
  // _ballStop = (e) => {
  //   this.isDragging = false;
  // };
  render() {
    const {
      title,
      subTitle,
      url,
      url2,
      playing,
      playing2,
      playbackRate,
      volume,
      duration,
      played,
      loaded,
      muted,

      contentPartSerial,
      partShow,
      isHovering,
      imageLO,
      isSetting,
      mediaTime,
      soundOn,
      opStartTime,
      opEndTime,

      edEndTime,
      isOpeningSkip,
      isEndingSkip,
      isFullScreen,
      menuBackOn,
      menuPart,
      menuPlay,
      menuPrev10,
      menuNext10,
      menuVolume,
      menuSetting,
      menuFull,
      pip,
      menuPip,
      wishFlag,
      isLoding,
      showRate,
      showKeyboard,
      menuRate,
      menuKeyboard,
      menuNext,
      nextList,
      imgSource,
      //snapshots,
      //stime,
    } = this.state;

    const { imgUrl } = this.props;
    // let playRate = parseInt(played * 100);
    // playRate = playRate + "%";

    const openingTime = this._msToTime(
      parseInt(opEndTime * 1000) - parseInt(opStartTime * 1000)
    );

    ////console.log(played.toFixed(3)*1000 )
    ////console.log(opStartTime, opEndTime)
    ////console.log(parseInt(duration * played))
    //console.log(isHovering)
    return (
      <Fragment>
        <div
          className={this.pos === 'pop' ? 'detail_layer_pop1' : null}
          onClick={this._showMenu}
          onMouseLeave={this._outMenu}
        >
          {/* <image src={imgSource} /> */}

          <Hotkeys
            keyName="space,left,right,up,down,esc,backspace,pageup,],["
            onKeyDown={this._onKeyDown}
            onKeyUp={this._onKeyUp}
          >
            <div className="vod_play_group">
              {/*오프닝 일때만 나올것.. 해당 타임 라인 시간에만..*/}
              <div
                className="snapshotContainer"
                // ref={(ref) => (this.snapshotRef = ref)}
                style={{ display: 'none' }}
              >
                {/* <img
                  ref={(ref) => (this.snapshootImgRef = ref)}
                  src={snapshots}
                  className="snapshotImg"
                />
                <div className="snapshotTime">
                  {this._msToTime(duration * stime * 1000)}
                </div> */}
              </div>
              {isHovering ? (
                <div className="live_hover" onMouseMove={this._hoverMove}>
                  <div
                    className="vod_back_btn"
                    onMouseEnter={this._toggleBack}
                    onMouseLeave={this._toggleBack}
                  >
                    <Tooltip title="닫기">
                      <a style={{ cursor: 'pointer' }} onClick={this._onBack}>
                        {menuBackOn ? (
                          <img src={imgUrl + '/img/player/back_o.png'} />
                        ) : (
                          <img src={imgUrl + '/img/player/back.png'} />
                        )}
                      </a>
                    </Tooltip>
                  </div>

                  <div
                    className="vod_menu_btn"
                    onMouseEnter={this._toggleMenu}
                    onMouseLeave={this._toggleMenu}
                  >
                    <Tooltip title="다른 화수 보기">
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={this._onTogglePart}
                        className="btn_part"
                      >
                        {menuPart ? (
                          <img src={imgUrl + '/img/player/menu_o.png'} />
                        ) : (
                          <img src={imgUrl + '/img/player/menu.png'} />
                        )}
                      </a>
                    </Tooltip>
                    {partShow ? (
                      <PartList
                        contentPartSerial={contentPartSerial}
                        onPlay={this._onInitPlay}
                        onHidePart={this._onHidePart}
                        progress={played.toFixed(3) * 100}
                        wishFlag={wishFlag}
                        toggleWish={this._toggleWish}
                      />
                    ) : null}
                  </div>

                  <div className="live_hover_group">
                    {isOpeningSkip ? (
                      <div className="time_right">
                        <em>
                          Opening MV<span>{openingTime.substr(3, 7)}</span>
                        </em>
                        <a
                          style={{ cursor: 'pointer' }}
                          onClick={() => this._skipTo(opEndTime)}
                        >
                          <img src={imgUrl + '/img/vod/skip.png'} />
                        </a>
                      </div>
                    ) : null}
                    {isEndingSkip ? (
                      <div className="time_right">
                        <em>
                          Ending MV<span>{openingTime.substr(3, 7)}</span>
                        </em>
                        <a
                          style={{ cursor: 'pointer' }}
                          onClick={() => this._skipTo(edEndTime)}
                        >
                          <img src={imgUrl + '/img/vod/skip.png'} />
                        </a>
                      </div>
                    ) : null}
                    <h1 onClick={this._showMenu}>
                      <img src={imageLO} />
                    </h1>
                    <h2 onClick={this._showMenu}>{title}</h2>
                    <h3 onClick={this._showMenu}>{subTitle}</h3>

                    <div
                      className="play_line"
                      onMouseDown={this._handleProgressEvent}
                      onMouseUp={this._handleProgressEvent}
                      onMouseEnter={this._handleProgressEvent}
                      onMouseMove={this._handleProgressEvent}
                      onMouseLeave={this._handleProgressEvent}
                      onTouchStart={this._handleProgressEvent1}
                      onTouchEnd={this._handleProgressEvent1}
                      onTouchMove={this._handleProgressEvent1}
                      style={{ cursor: 'pointer' }}
                      onClick={() => console.log('...')}
                    >
                      <div
                        style={{
                          width: played.toFixed(3) * 100 + '%',
                          zIndex: 99999999,
                        }}
                        className="play_line_ing"
                      ></div>
                      <span
                        style={{
                          left: played.toFixed(3) * 100 + '%',
                          zIndex: 999999999,
                        }}
                        className="play_line_cur"
                        // onMouseEnter={this._ballDrag}
                        // onMouseMove={this._ballMove}
                        // onMouseLeave={this._ballStop}
                      ></span>
                      <span
                        style={{
                          width: loaded.toFixed(3) * 100 + '%',
                          zIndex: 99999999,
                          backgroundColor: '#000',
                          opacity: 0.2,
                        }}
                        className="play_line_loaded"
                        // onMouseEnter={this._ballDrag}
                        // onMouseMove={this._ballMove}
                        // onMouseLeave={this._ballStop}
                      ></span>
                      <div
                        className="play_line_remain"
                        style={{ background: '#fff' }}
                      ></div>
                    </div>

                    <div className="control">
                      <div className="float_left">
                        <span
                          style={{ cursor: 'pointer' }}
                          onClick={this._onPlayToggle}
                          onMouseEnter={this._togglePlay}
                          onMouseLeave={this._togglePlay}
                        >
                          {playing ? (
                            menuPlay ? (
                              <img
                                src={imgUrl + '/img/player/pause_btn_o.png'}
                                className="btn_pause"
                              />
                            ) : (
                              <img
                                src={imgUrl + '/img/player/pause_btn.png'}
                                className="btn_pause"
                              />
                            )
                          ) : menuPlay ? (
                            <img
                              src={imgUrl + '/img/player/play_btn_o.png'}
                              className="btn_play"
                            />
                          ) : (
                            <img
                              src={imgUrl + '/img/player/play_btn.png'}
                              className="btn_play"
                            />
                          )}
                        </span>

                        <span
                          onMouseEnter={this._togglePrev10}
                          onMouseLeave={this._togglePrev10}
                          style={{ cursor: 'pointer' }}
                          onClick={this._onBackward}
                        >
                          {menuPrev10 ? (
                            <img
                              src={imgUrl + '/img/player/pre_10_o.png'}
                              className="btn_pre"
                            />
                          ) : (
                            <img
                              src={imgUrl + '/img/player/pre_10.png'}
                              className="btn_pre"
                            />
                          )}
                        </span>

                        <span
                          onMouseEnter={this._toggleNext10}
                          onMouseLeave={this._toggleNext10}
                          style={{ cursor: 'pointer' }}
                          onClick={this._onForward}
                        >
                          {menuNext10 ? (
                            <img
                              src={imgUrl + '/img/player/next_10_o.png'}
                              className="btn_next"
                            />
                          ) : (
                            <img
                              src={imgUrl + '/img/player/next_10.png'}
                              className="btn_next"
                            />
                          )}
                        </span>

                        <span
                          style={{ cursor: 'pointer' }}
                          onMouseEnter={this._toggleSound}
                          onClick={this._toggleMuted}
                        >
                          {muted ? (
                            menuVolume ? (
                              <img
                                src={imgUrl + '/img/player/sound_off_btn_o.png'}
                                className="btn_control"
                              />
                            ) : (
                              <img
                                src={imgUrl + '/img/player/sound_off_btn_o.png'}
                                className="btn_control"
                              />
                            )
                          ) : menuVolume ? (
                            <img
                              src={imgUrl + '/img/player/sound_btn_o.png'}
                              className="btn_control"
                            />
                          ) : (
                            <img
                              src={imgUrl + '/img/player/sound_btn.png'}
                              className="btn_control"
                            />
                          )}
                        </span>

                        {soundOn ? (
                          <div
                            className="sound_line"
                            style={{
                              zIndex: 9999999,
                              left: 185,
                              cursor: 'pointer',
                            }}
                            onMouseDown={this._handleVolumeEvent}
                            onMouseUp={this._handleVolumeEvent}
                            onMouseMove={this._handleVolumeEvent}
                            onTouchStart={this._handleVolumeEvent1}
                            onTouchEnd={this._handleVolumeEvent1}
                            onTouchMove={this._handleVolumeEvent1}
                            onClick={() => console.log('...')}
                          >
                            {' '}
                            {/*onMouseLeave = {this._toggleSound}*/}
                            <div
                              style={{
                                width:
                                  volume === 1 ? 0.9 * 100 : volume * 100 + '%',
                                zIndex: 99999999,
                              }}
                              className="sound_cur"
                            ></div>
                            <em
                              style={{
                                left:
                                  volume === 1 ? 0.8 * 100 : volume * 100 + '%',
                              }}
                              className="sound_ing"
                            ></em>
                            <div
                              className="sound_line_remain"
                              style={{
                                background: 'rgb(255, 255, 255, 0.3)',
                              }}
                            ></div>
                          </div>
                        ) : null}
                        <span style={soundOn ? { left: 300 } : { left: 200 }}>
                          {this._msToTime(duration * played * 1000)} -{' '}
                          {mediaTime === undefined
                            ? '??:??'
                            : this._msToTime(mediaTime * 1000)}
                        </span>
                      </div>
                      <div className="float_right">
                        <span
                          style={{ color: '#fff' }}
                          onMouseEnter={this._toggleMouseNext}
                          onMouseLeave={this._toggleMouseNext}
                        >
                          <img src="/img/player/ico_next.png" />
                          {menuNext ? (
                            nextList ? (
                              <div
                                className="set_pop0"
                                onClick={() => this._onNextPlayInfo()}
                              >
                                <div className="vod_menu_group">
                                  <dl className="on">
                                    <dt>
                                      {nextList[0].subTitle}
                                      <div className="lin_bg">
                                        <div style={{ width: '100%' }}></div>
                                      </div>
                                    </dt>
                                    <dd>
                                      <img src={nextList[0].img} />
                                      <div className="vod_next_group">
                                        {nextList[0].episode}...
                                      </div>
                                    </dd>
                                  </dl>
                                </div>
                              </div>
                            ) : (
                              <div className="set_pop01">
                                <div className="vod_menu_group">
                                  <dl className="on">
                                    <dt>다음 화수가 존재하지 않습니다.</dt>
                                  </dl>
                                </div>
                              </div>
                            )
                          ) : null}
                        </span>
                        <span
                          onClick={this._toggleRate}
                          onMouseEnter={this._toggleMouseRate}
                          onMouseLeave={this._toggleMouseRate}
                        >
                          {menuRate ? (
                            <img
                              src={imgUrl + '/img/vod/multy_btn_o.png'}
                              className="btn_control"
                            />
                          ) : (
                            <img
                              src={imgUrl + '/img/vod/multy_btn.png'}
                              className="btn_control"
                            />
                          )}

                          {showRate ? (
                            <div className="set_pop2">
                              <dl>
                                <dt
                                  style={
                                    playbackRate === 3
                                      ? { color: '#ff5d24' }
                                      : null
                                  }
                                  onClick={() => this._onSetPlaybackRate(3)}
                                >
                                  × 3.0
                                </dt>
                                <dt
                                  style={
                                    playbackRate === 2.5
                                      ? { color: '#ff5d24' }
                                      : null
                                  }
                                  onClick={() => this._onSetPlaybackRate(2.5)}
                                >
                                  × 2.5
                                </dt>
                                <dt
                                  style={
                                    playbackRate === 2
                                      ? { color: '#ff5d24' }
                                      : null
                                  }
                                  onClick={() => this._onSetPlaybackRate(2)}
                                >
                                  × 2.0
                                </dt>
                                <dt
                                  style={
                                    playbackRate === 1.5
                                      ? { color: '#ff5d24' }
                                      : null
                                  }
                                  onClick={() => this._onSetPlaybackRate(1.5)}
                                >
                                  × 1.5
                                </dt>
                                <dt
                                  style={
                                    playbackRate === 1
                                      ? { color: '#ff5d24' }
                                      : null
                                  }
                                  onClick={() => this._onSetPlaybackRate(1)}
                                >
                                  × 1.0
                                </dt>
                              </dl>
                            </div>
                          ) : null}
                        </span>
                        <span
                          onClick={this._toggleKeyboard}
                          onMouseEnter={this._toggleMouseKeyboard}
                          onMouseLeave={this._toggleMouseKeyboard}
                        >
                          {menuKeyboard ? (
                            <img
                              src={imgUrl + '/img/vod/key_btn_o.png'}
                              className="btn_control"
                            />
                          ) : (
                            <img
                              src={imgUrl + '/img/vod/key_btn.png'}
                              className="btn_control"
                            />
                          )}
                          {showKeyboard ? (
                            <div className="set_pop3"> </div>
                          ) : null}
                        </span>

                        <span
                          onClick={this._onToggleSetting}
                          onMouseEnter={this._toggleSetting}
                          onMouseLeave={this._toggleSetting}
                        >
                          {menuSetting ? (
                            <img
                              src={imgUrl + '/img/live_img/set_btn_o.png'}
                              className="btn_control"
                            />
                          ) : (
                            <img
                              src={imgUrl + '/img/live_img/set_btn.png'}
                              className="btn_control"
                            />
                          )}

                          {isSetting ? (
                            <Setting
                              onChangeBitrate={this._onChangeBitrate}
                              onChangeAutoNext={this._onChangeAutoNext}
                              onChangeAutoSkip={this._onChangeAutoSkip}
                              onChangeAutoSkipEnd={this._onChangeAutoSkipEnd}
                            />
                          ) : /*
                                        <div className="set_pop">
                                            <dl>
                                                <dt>화질설정</dt>
                                                <dd><a style={{ cursor: 'pointer'}} className="on">자동</a></dd>
                                                <dd><a style={{ cursor: 'pointer'}} onClick={()=>this._onChangeBitrate('1080P')}>1080P</a></dd>
                                                <dd><a style={{ cursor: 'pointer'}} onClick={()=>this._onChangeBitrate('720P')}>720P</a></dd>
                                            </dl>
                                            <dl>
                                                <dt>재생설정</dt>
                                                <dd><a href="#">연속재생</a></dd>
                                                <dd><a href="#">오픈닝 스킵</a></dd>
                                                <dd><a href="#">엔딩 스킵</a></dd>
                                            </dl>
                                        </div>
                                        */
                          null}
                        </span>

                        <span
                          onMouseEnter={this._toggleMenuPip}
                          onMouseLeave={this._toggleMenuPip}
                          onClick={this._togglePip}
                        >
                          {menuPip ? (
                            <img src={imgUrl + '/img/vod/pop_btn_o.png'} />
                          ) : (
                            <img src={imgUrl + '/img/vod/pop_btn.png'} />
                          )}
                        </span>

                        <span
                          onMouseEnter={this._toggleFull}
                          onMouseLeave={this._toggleFull}
                          style={{ cursor: 'pointer' }}
                          onClick={this._onFullscreen}
                        >
                          {isFullScreen ? (
                            menuFull ? (
                              <img src={imgUrl + '/img/player/unall_o.png'} />
                            ) : (
                              <img src={imgUrl + '/img/player/unall.png'} />
                            )
                          ) : menuFull ? (
                            <img src={imgUrl + '/img/player/all_o.png'} />
                          ) : (
                            <img src={imgUrl + '/img/player/all.png'} />
                          )}
                          {/* isFullScreen ?  <img src='/img/player/unall.png'/> : <img src="/img/live_img/all_btn.png" /> */}
                        </span>
                      </div>
                      <div className="clear"></div>
                    </div>
                  </div>
                </div>
              ) : null}
              {isLoding === false ? null : (
                <div
                  className="vod_loading"
                  style={{
                    zIndex: 9999,
                    position: 'absolute',
                    top: window.innerHeight / 2,
                    left: '50%',
                    marginLeft: -50,
                    marginTop: -80,
                  }}
                >
                  <img src={imgUrl + '/img/vod/vod_loading.png'} />
                  <div style={{ color: '#fff', paddingTop: 10 }}>
                    영상을 불러오고 있습니다.
                  </div>
                </div>
              )}

              <div
                className="play_group"
                onClick={this._showMenu}
                style={{ zIndex: 999 }}
                onMouseMove={this._playMouseMove}
              >
                <ReactPlayer
                  url={url}
                  playing={playing}
                  controls={false}
                  muted={muted}
                  ref={(ref) => (this.video = ref)}
                  light={false}
                  width="100%"
                  height="100%"
                  volume={volume}
                  playbackRate={playbackRate}
                  onReady={this._onReady}
                  onProgress={this._onProgress}
                  onDuration={this._onDuration}
                  onSeek={this._onSeek}
                  onStart={this._onStart}
                  //onEnded={this._onProgress}
                  onError={this._onError}
                  onEnablePIP={this._onEnablePIP}
                  onDisablePIP={this._onDisablePIP}
                  pip={pip}
                />
              </div>
            </div>
            <div className="snapshotPlayer">
              <ReactPlayer
                url={url2}
                playing={playing2}
                width={200}
                ref={(ref) => (this.video2 = ref)}
                muted={true}
                onReady={this._onReady2}
                onSeek={this._onSeek2}
              />
            </div>

            {/*
            <div style={{margin: 0, padding: 0}} onClick={this._onPlayToggle} onMouseEnter={()=>this._onToggleScreen(true)} onMouseLeave={()=>this._onToggleScreen(false)}>
                <ReactPlayer 
                    url={url} 
                    playing={playing} 
                    controls={false}
                    muted={muted}
                    ref={ref=>this.video=ref}
                    light={false}
                    width='100%' 
                    height='100%'
                    volume={volume}
                    playbackRate={playbackRate}
                    onReady={this._onReady}
                    onProgress={this._onProgress}
                    onDuration={this._onDuration}
                    onSeek={e => console.log('onSeek', e)}
                    onStart={() => console.log('onStart')}
                    //onEnded={this._onProgress}
                    onError={e => console.log('onError', e)}
                />
            </div>
            {mouseScreen ? (
                <div style={{position: 'absolute', right: 10, top: 10}}>
                    <PauseGoods
                        contentSerial={contentSerial}
                    />
                </div>
            ) : null}
            <div>
                {title} <br />
                {subTitle}
            </div>
            { partShow ? (
                <div>
                    <PartList
                        contentPartSerial={ contentPartSerial }
                        onPlay = {this._onInitPlay }
                        onHidePart = { this._onHidePart }
                    />
                </div>
            ) : null } 
              
            <div style={{display: 'flex'}}>
                <div style={{ flexDirection: 'row'}}>
                    <button onClick={()=>this._onChangeBitrate('480P')}>420P</button>
                    <button onClick={()=>this._onChangeBitrate('720P')}>720P</button>
                    <button onClick={()=>this._onChangeBitrate('1080P')}>1080P</button>
                </div>
                
            </div>
            <div style={{display: 'flex'}}>
                <div style={{ flexDirection: 'row'}}>
                    <button onClick={this._onPlayToggle}>{playing ? 'Pause' : 'Play'}</button>
                    <button onClick={this._onStop}>STOP</button>
                    <button onClick={this._onFullscreen}>FULLSCREEN</button>
                    <button onClick={this._onShowPart}>화수정보</button>
                </div>
            </div>
            <div style={{display: 'flex'}}>
                <div style={{ flexDirection: 'row'}}>
                    <button onClick={this._onBackward}>뒤로 10초</button>
                    <button onClick={this._onForward}>앞으로 10초</button>
                   
                </div>
            </div>
            
            <div style={{display: 'flex'}}>
                <div style={{ flexDirection: 'row'}}>
                    <div>duration: {duration}</div>
                    <div>played: {played.toFixed(3)}</div>
                    <div>elapsed: {duration * played}</div>
                    <div>remaining: {duration * (1 - played)}</div>
                    <div>loaded: {loaded}</div>
                    <div>volume: {volume}</div>
                </div>
            </div>
            <div style={{display: 'flex'}}>
                <div style={{ flexDirection: 'colum'}}>
                    <div style={{ width: 1000, height: 30, backgroundColor: 'gray'}}></div>
                    <div style={{ width: playRate, height: 30, backgroundColor: 'red'}}>{played * 1000}</div>
                </div>
            </div>
            <div style={{display: 'flex', width: '100%'}}>
                <div style={{ flexDirection: 'row'}}>
                    <div>seek</div>
                    <input
                        type='range' min={0} max={1} step='any'
                        value={played}
                        style={{width: 500}}
                        onMouseDown={this._onSeekMouseDown}
                        onChange={this._onSeekChange}
                        onMouseUp={this._onSeekMouseUp}
                    />
                </div>
            </div>
            <div style={{display: 'flex', width: '100%'}}>
                <div style={{ flexDirection: 'row'}}>
                    <div>volume</div>
                    <input 
                        type='range' min={0} max={1} step='any' 
                        value={volume} 
                        onChange={this._onVolumeChange} 
                    />
                </div>
            </div>
            <div style={{display: 'flex', width: '100%'}}>
                <div style={{ flexDirection: 'row'}}>
                    <div>음소거</div>
                    <input id='muted' type='checkbox' checked={muted} onChange={this._onToggleMuted} />
                </div>
            </div>
            <div style={{display: 'flex', width: '100%'}}>
                <div style={{ flexDirection: 'row'}}>
                    <button onClick={this._onSetPlaybackRate} value={1}>1x</button>
                    <button onClick={this._onSetPlaybackRate} value={1.5}>1.5x</button>
                    <button onClick={this._onSetPlaybackRate} value={2}>2x</button>
                </div>
            </div>
            */}
          </Hotkeys>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(Player)));
